import { render, staticRenderFns } from "./class-calendar.vue?vue&type=template&id=50d6832d&scoped=true&"
import script from "./class-calendar.vue?vue&type=script&lang=js&"
export * from "./class-calendar.vue?vue&type=script&lang=js&"
import style0 from "./class-calendar.vue?vue&type=style&index=0&id=50d6832d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d6832d",
  null
  
)

export default component.exports